import React, { useState, useEffect, useRef } from "react";
import { useHistory, useParams } from "react-router-dom";
import {
  Box,
  Slide,
  Stack,
  Typography,
  Button,
  Tabs,
  Tab,
  Avatar,
  Divider,
  IconButton,
} from "@mui/material";
import PageHeader from "./../../components/PageHeader";
import ProfileBanner from "./../../components/ProfileBanner";
import { Images } from "./../../assets/common";
import TipContainer from "./../../components/TipContainer";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import DoneIcon from "@mui/icons-material/Done";
import ArrowRow from "../../components/ArrowRow";
import LockIcon from "@mui/icons-material/Lock";
import SuccessPopup from "./../../components/SuccessPopup";
import AssetPopup from "../../components/AssetsPopup";
import MusicCard from "./../../components/MusicCard";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import AddIcon from "@mui/icons-material/Add";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import IosShareIcon from "@mui/icons-material/IosShare";
import "./index.scss";
import ShuffleIcon from "@mui/icons-material/Shuffle";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import useMediaQuery from "@mui/material/useMediaQuery";

import {
  fullName,
  isOwner,
  getErrorString,
  validateUrl,
  isOwnerId,
  putRecors,
  HMS,
  copyToClipboard,
  getUserDetail,
  onShare,
  dynamicLink,
  truncate,
} from "./../../constants/function";
import ApiService from "./../../services/api-service";
import Loader from "../../components/Loader";
import notifier from "../../components/Notifier";
import TipPopup from "../../components/TipPopup";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { setbalance } from "./../../action/balance";
import { getBalance } from "../../asyncAction/asyncBalance";
import Chips from "../../components/Chips";
import { addSongAction, addSongsAction } from "./../../action/songs";
import AddMusicToPlaylist from "../../components/AddMusicToPlaylist";
import NoData from "../../components/Nodata";
import ConfirmPopup from "../../components/ConfirmPopup";
import Chat from "../../components/Chat";
import DirectChat from "../../components/DirectChat";
import VideoCard from "../../components/VideoCard";
import VideoPopup from "../../components/VideoPlayer";
import { useTranslation } from "react-i18next";
import { SortableElement, sortableHandle } from "react-sortable-hoc";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { useTheme } from "@mui/material/styles";
import { TabPanel } from "@mui/lab";
import PropTypes from "prop-types";
import ArtistProfileRow from "../../components/ArtistProfileRow";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import HMSTag from "../../components/HMS/hms";
import OutsideClickHandler from "react-outside-click-handler";
import DropDown from "../../components/DropDown";
import DropMenu from "../../components/DropMenu";
import ArtistContent from "../../components/ArtistContent";

export default function ArtistProfile() {
  const { t } = useTranslation("common");
  const [video, setVideo] = React.useState(null);
  const [loaded, setLoaded] = React.useState(false);
  const [chatOpen, setChatOpen] = useState(false);
  const [showConfirm, setShowConfirm] = React.useState(false);
  const [count, setCount] = useState(0);
  const dispatch = useDispatch();
  const [message, setMessage] = useState(t("success.message7"));
  const [openTip, setOpenTip] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const [userData, setUserData] = useState({});
  const history = useHistory();
  const params = new URLSearchParams(history.location.search);
  const referralId = params.get("referralId");
  const [open, setOpen] = useState(false);
  const [viewAsset, setSetViewAsset] = React.useState(false);
  const [music, setMusic] = useState([]);
  const [nftMusic, setNftMusic] = useState([]);
  const [playlistMusic, setPlaylistMusic] = useState([]);
  const [playlistNft, setPlaylistNft] = useState([]);
  const [albums, setAlbums] = useState([]);
  const [pageNo, setPageno] = useState(1);
  const [showPlaylist, setShowPlaylist] = React.useState(false);
  const [selectedId, setSelectedAlbum] = React.useState();
  const [userName, setUserName] = React.useState("");
  const [videos, setVideos] = React.useState([]);
  const [currentTab, setCurrentTab] = React.useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [trendingMusic, setTrendingMusic] = React.useState({});
  const [isTrending, setIsTrending] = React.useState(true);
  const [topMusic, setTopMusic] = React.useState([]);
  const [menu, setMenu] = React.useState(false);
  const [twitter, setTwitter] = React.useState("");
  const [instagram, setInstagram] = React.useState("");
  const [tiktok, setTiktok] = React.useState("");
  const [option, setOption] = React.useState(false);
  const [studioOption, setStudioOption] = React.useState(false);
  const userDetail = getUserDetail();
  const handleClickOpen = () => {
    setSetViewAsset(true);
  };

  const handleClose = () => {
    setSetViewAsset(false);
  };
  const handleTip = async (amount, id, type, currency) => {
    if (amount) {
      try {
        const payload = {
          id: id,
          tipAmount: amount,
          type: type,
          currency: currency,
        };
        setLoading(true);
        const response = await ApiService.TIP_ARTIST(payload);
        setLoading(false);
        notifier.success(response["result"]);
        setOpenTip(false);
        dispatch(getBalance());
      } catch (error) {
        setLoading(false);
        notifier.error(getErrorString(error));
      }
    } else {
      setOpenTip(false);
    }
  };

  // useEffect(() => {
  //   topRef.current.scrollIntoView({ behavior: "smooth" });
  // }, [id]);

  useEffect(() => {
    setVideos([]);
    const getUserData = async (_id) => {
      setLoading(true);
      try {
        const response = await ApiService.USER_DETAILS(_id);
        setLoading(false);
        if (
          response["result"] &&
          response["result"]["top5Music"] &&
          response["result"]["top5Music"].length > 0
        ) {
          response["result"]["top5Music"].forEach((m, index) => {
            m["uploader"]["isSubscribed"] = response["result"]["isSubscribed"];
          });
        }
        setUserData(response["result"]);
        setUserName(fullName(response["result"]));
        setTwitter(response["result"]?.twitterLink);
        setInstagram(response["result"]?.instagramLink);
        setTiktok(response["result"]?.tikTokLink);

        if (active !== 0) {
          setActive(0);
        }
        if (window.location.href.includes("referralId=")) {
          putRecors({
            id: response["result"]._id,
            referralLink: window.location.href,
            eventType: ["sharedInbound"],
            eventAsset: response["result"]._id,
            eventValue: ["Profile"],
            socialMedia: null,
            referralId: referralId,
          });
        } else {
          putRecors({
            id: response["result"]._id,
            referralLink: window.location.href,
            eventType: ["view"],
            eventAsset: response["result"]._id,
            eventValue: ["Profile"],
            socialMedia: null,
          });
        }
      } catch (error) {
        setLoading(false);
      }
    };
    if (id) {
      getUserData(id);
      getTrendingMusic(id);
      // getTopMusic(id, pageNo);
      setMusic([]);
      // getMyMusic(id, pageNo);
    }
    setChatOpen(false);
  }, [id]);

  /**
   * @param  {} artistId
   * subscribe an artist
   */
  const subscribe = async (artistId) => {
    try {
      setLoading(true);
      const response = await ApiService.SUBSCRIBE_ARTIST({
        artistId: id,
        currency: "siki",
      });
      const temp = userData;
      temp["isSubscribed"] = true;
      temp["subscribedStatus"] = "Active";
      temp["subscriptionStatus"] = "enabled";
      setUserData({ ...temp });
      setLoading(false);
      setOpen(true);
      setShowConfirm(false);
      dispatch(getBalance());
    } catch (error) {
      setLoading(false);
      setShowConfirm(false);
      notifier.error(getErrorString(error));
      history.push("/app/Wallet/addBalance");
    }
  };
  /**
   * @param  {} artistId
   * UNSUBSCRIBE_ARTIST an artist
   */
  const unSubscribe = async (artistId) => {
    try {
      setLoading(true);
      const response = await ApiService.UNSUBSCRIBE_ARTIST({
        artistId: id,
        currency: "siki",
      });
      setMessage(t("success.message8"));
      const temp = userData;
      // temp["isSubscribed"] = false;
      temp["subscribedStatus"] = "Unsubscribed";
      setUserData({ ...temp });
      setLoading(false);
      setOpen(true);
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };
  /**
   * @param  {} artistId
   * follow unfollow artist
   */
  const follow = async (artistId) => {
    try {
      setLoading(true);
      const payload = {
        following: artistId,
        status: !userData["isFollowed"],
      };
      const response = userData["isFollowed"]
        ? await ApiService.UNFOLLOW(payload)
        : await ApiService.FOLLOW(payload);
      setLoading(false);
      const data = userData;
      data["isFollowed"] = !userData["isFollowed"];
      // data["followerCount"] =
      //   response["result"]["updatedCount"]["myFollowerCount"];
      // data["followingCount"] =
      //   response["result"]["updatedCount"]["myFollowingCount"];

      setUserData({ ...data });
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };
  const [active, setActive] = useState(0);
  const handleTabSwitch = (e, tab) => {
    // console.log("handle tab switch", tab);
    if (active === tab) return;
    setActive(tab);
    setCount(0);
    setMusic((m) => []);
    setNftMusic([]);
    setPlaylistNft([]);
    setVideos([]);
    switch (tab) {
      case 0:
        setPageno(1);
        getMyMusic(userData["_id"], 1);
        break;
      case 1:
        setMusic([]);
        setPageno(1);
        getPlayLists(userData["_id"]);
        break;
      case 2:
        setMusic([]);
        setPageno(1);
        getNfts(userData["_id"], 1, []);
        break;
      case 3:
        setMusic([]);
        setPageno(1);
        getAlbum(userData["_id"], 1);
        break;
      case 4:
        setMusic([]);
        setPageno(1);
        getVideos(userData["_id"], 1);
        break;
      default:
        break;
    }
  };
  const getMyMusic = async (_id, pageNo) => {
    try {
      setLoading(true);
      const response = await ApiService.TOP_ALBUM_MUSIC_STUDIO_LIST({
        id: _id,
        type: "music",
        pageNo: pageNo,
        pageSize: 14,
      });

      setLoading(false);
      // setCount(response["result"]["totalCount"]);
      setLoaded(response["result"].length < 14 ? true : false);
      if (music.length == 0) setMusic([...response["result"]]);
      else setMusic((prevMusic) => [...prevMusic, ...response["result"]]);
    } catch (error) {
      setLoading(false);
      if (getErrorString(error) !== "Artist has no music") {
        notifier.error(getErrorString(error));
      } else if (getErrorString(error) === "Artist has no music")
        setLoaded(true);
    }
  };
  const getPlayLists = async (_id) => {
    try {
      setLoading(true);
      const response = await ApiService.TOP_ALBUM_MUSIC_STUDIO_LIST({
        id: _id,
        type: "studio",
        pageNo: pageNo,
        pageSize: 16,
      });

      setLoading(false);
      // setCount(response["result"]["totalCount"]);
      if (response["result"].length > 0)
        setPlaylistMusic([...response["result"]]);
      else setPlaylistMusic([...playlistMusic, ...response["result"]]);
      // setPlaylistMusic([...response["result"]]);
    } catch (error) {
      setLoading(false);
      if (getErrorString(error) !== "Artist has no music")
        notifier.error(getErrorString(error));
    }
  };
  const getNfts = async (_id, pageNo, data) => {
    try {
      setLoading(true);
      const response = await ApiService.TOP_ALBUM_MUSIC_STUDIO_LIST({
        id: _id,
        type: "nft",
        pageNo: pageNo,
        pageSize: 16,
      });

      setLoading(false);
      setLoaded(response["result"].length < 16 ? true : false);
      if (data.length > 0) setNftMusic([...nftMusic, ...response["result"]]);
      else setNftMusic([...response["result"]]);
    } catch (error) {
      setLoading(false);
      if (getErrorString(error) !== "Artist has no NFT")
        notifier.error(getErrorString(error));
    }
  };
  const getPlaylistNfts = async (_id, pageNo) => {
    try {
      setLoading(true);
      const response = await ApiService.USER_NFT_PLAYLIST({
        userId: _id,
        pageNo: pageNo,
        pageSize: 16,
      });

      setLoading(false);
      setLoaded(response["result"].length < 16 ? true : false);
      setPlaylistNft([...playlistNft, ...response["result"]]);
    } catch (error) {
      setLoading(false);
      if (getErrorString(error) !== "Artist has no NFT")
        notifier.error(getErrorString(error));
    }
  };
  const getAlbum = async (_id, pageNo) => {
    try {
      setLoading(true);
      const response = await ApiService.TOP_ALBUM_MUSIC_STUDIO_LIST({
        id: _id,
        type: "album",
        pageNo: pageNo,
        pageSize: 16,
      });

      setLoading(false);
      // setCount(response["result"]["totalCount"]);
      setLoaded(response["result"].length < 16 ? true : false);
      if (response["result"].length > 0)
        setAlbums([...albums, ...response["result"]]);
      else setAlbums([...response["result"]]);
    } catch (error) {
      setLoading(false);
      if (getErrorString(error) !== "Artist has no NFT")
        notifier.error(getErrorString(error));
    }
  };

  const getTopMusic = async (_id, pageNo) => {
    try {
      setLoading(true);
      const response = await ApiService.TOP_ALBUM_MUSIC_STUDIO_LIST({
        id: _id,
        type: "top",
        pageNo: pageNo,
        pageSize: 16,
      });

      setLoading(false);
      // console.log("Response ", response);
      setLoaded(response["result"].length < 16 ? true : false);
      if (response["result"].length > 0)
        setTopMusic([...topMusic, ...response["result"]]);
      else setTopMusic([...response["result"]]);
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };

  const toggleMenu = (value, id, index, tab, isplaylist, isMusic) => {
    setSelectedAlbum(id);
    if (value && id) makeAction(value, id, index, tab, isMusic);
  };
  const makeAction = async (key, id, index, tab, isMusic) => {
    switch (key) {
      case "m2":
        if (tab === 0 && topMusic.length) {
          if (
            !isOwnerId(userData["_id"]) &&
            !userData["isSubscribed"] &&
            topMusic[index]["private"]
          )
            notifier.error(t("notifier.error.toast15"));
          else {
            dispatch(addSongAction(topMusic[index], null, true));
          }
        } else if (tab === 1) {
          if (
            tab === 1 &&
            music[index]["uploader"] &&
            !music[index]["uploader"]["isSubscribed"] &&
            music[index]["private"]
          ) {
            notifier.error(t("notifier.error.toast15"));
          } else {
            dispatch(addSongAction(music[index], null, true));
          }
        } else if (tab === 3) {
          if (!nftMusic[index]["isSubscribed"] && nftMusic[index]["private"])
            notifier.error(t("notifier.error.toast15"));
          else dispatch(addSongAction(nftMusic[index], null, true));
        } else if (tab === 2 || tab === 5) {
          const isPlaylist = tab === 2 || tab === 5 ? true : false;
          dispatch(
            addSongAction(
              tab === 0
                ? topMusic[index]
                : tab === 1
                ? music[index]
                : tab === 3 && nftMusic[index]["musicDetails"]
                ? nftMusic[index]["musicDetails"]
                : music[index],
              isPlaylist ? music["_id"] : null,
              true
            )
          );
        }

        break;
      case "m3":
        if (
          tab === 0 &&
          topMusic[index]["uploader"] &&
          !topMusic[index]["uploader"]["isSubscribed"] &&
          topMusic[index]["private"]
        )
          notifier.error(t("notifier.error.toast15"));
        else if (
          tab === 1 &&
          music[index]["uploader"] &&
          !music[index]["uploader"]["isSubscribed"] &&
          music[index]["private"]
        )
          notifier.error(t("notifier.error.toast15"));
        else if (
          tab === 3 &&
          !nftMusic[index]["isSubscribed"] &&
          nftMusic[index]["private"]
        )
          notifier.error(t("notifier.error.toast15"));
        else setShowPlaylist(true);
        break;
      case "m1":
        if (tab != undefined && tab === 0) {
          history.push(
            topMusic[index]?.nftId
              ? `/app/SongDetail/${topMusic[index]?.nftId}`
              : `/app/SongDetails/${id}`
          );
        } else if (tab && tab === 1) {
          history.push(
            music[index]?.nftId
              ? `/app/SongDetail/${music[index]?.nftId}`
              : `/app/SongDetails/${id}`
          );
        } else if (
          tab &&
          tab === 3 &&
          !nftMusic[index]["isSubscribed"] &&
          nftMusic[index]["private"]
        ) {
          notifier.error(t("notifier.error.toast10"));
        } else {
          history.push(
            `/app/SongDetail/${
              nftMusic[index]["nftId"]
                ? nftMusic[index]["nftId"]
                : nftMusic[index]["_id"]
            }`
          );
        }
        break;
      case "m26":
        if (tab === 2) {
          if (
            !isOwner(
              playlistMusic[index]["createdByDetails"]
                ? playlistMusic[index]["createdByDetails"]["email"]
                : ""
            ) &&
            playlistMusic[index]["createdByDetails"] &&
            !playlistMusic[index].isSubscribed &&
            playlistMusic[index]["private"]
          )
            notifier.error(t("notifier.error.toast15"));
          else {
            const tempMusic = await getPlayListMusic(id);
            dispatch(addSongsAction(tempMusic, false, id, 0));
          }
        } else if (tab === 4) {
          dispatch(addSongsAction(albums[index]["music"], false, null, 0, id));
        } else if (
          !isOwner(
            playlistNft[index]["owner"]
              ? playlistNft[index]["owner"]["email"]
              : ""
          ) &&
          !playlistNft[index]["isSubscribed"] &&
          playlistNft[index]["private"]
        )
          notifier.error(t("notifier.error.toast15"));
        else {
          const tempMusic = await getPlayListMusic(id);
          // dispatch(addSongsAction(tempMusic, false, id, 0));
          tempMusic.forEach((m, index) => dispatch(addSongAction(m, id, true)));
        }
        break;
      case "m27":
        if (
          tab === 5 &&
          playlistNft[index]["owner"] &&
          playlistNft[index]["owner"]["_id"]
        )
          history.push(
            `/app/PlaylistStatics/${id}/${playlistNft[index]["owner"]["_id"]}`
          );
        else
          history.push(
            `/app/PlaylistStatics/${id}/${playlistMusic[index]["createdBy"]}`
          );
        break;
      case "m28":
        history.push(`/app/AlbumDetail/${albums[index]["_id"]}`);
        break;
      case "m8":
        if (tab === 2 && playlistMusic[index]["nftId"]) {
          if (
            !isOwnerId(playlistMusic[index]["owner"]) &&
            !playlistMusic[index]["isSubscribed"] &&
            playlistMusic[index]["private"]
          )
            notifier.error(t("notifier.error.toast9"));
          else
            history.push(
              `/app/PlaylistNftDetail/${playlistMusic[index]["nftId"]}`
            );
        } else if (tab === 3) {
          if (isMusic) {
            if (
              !isOwner(
                music[index]["owner"] ? music[index]["owner"]["email"] : ""
              ) &&
              !music[index]["isSubscribed"] &&
              music[index]["private"]
            )
              notifier.error(t("notifier.error.toast9"));
            else history.push(`/app/NftDetail/${id}`);
          } else if (
            !isOwner(
              nftMusic[index]["owner"] ? nftMusic[index]["owner"]["email"] : ""
            ) &&
            !nftMusic[index]["isSubscribed"] &&
            nftMusic[index]["private"]
          )
            notifier.error(t("notifier.error.toast9"));
          else history.push(`/app/NftDetail/${nftMusic[index]["nftId"]}`);
        }
        break;
      default:
        break;
    }
  };

  const getPlayListMusic = async (_id) => {
    try {
      setLoading(true);
      const response = await ApiService.PLAYLIST_DETAIL({
        _id: _id,
        pageNo: pageNo,
        pageSize: 16,
      });

      setLoading(false);

      return response["result"]["music"] || [];
    } catch (error) {
      setLoading(false);
      if (getErrorString(error) !== "Artist has no music")
        notifier.error(getErrorString(error));
    }
  };

  const flaguser = async () => {
    try {
      setLoading(true);
      const response = await ApiService.FLAG_USER({
        message: "Reason",
        assetId: userData["_id"],
        verify: userData["_id"],
      });
      notifier.success(t("notifier.success.toast8"));
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  const handleScroll = async (target) => {
    var a = target.scrollTop;
    var b = target.scrollHeight - target.clientHeight;

    if ((a / b) * 100 > 80 && !loaded && !loading) {
      // run a function called doSomething
      const next = pageNo + 1;
      setPageno(next);
      switch (active) {
        case 0:
          getMyMusic(userData["_id"], next);
          break;
        case 1:
          // getPlayLists(userData["_id"]);
          break;
        case 2:
          getNfts(userData["_id"], next, nftMusic);
          break;
        case 3:
          getAlbum(userData["_id"]);
          break;
        // case 5:
        //   getPlaylistNfts(userData["_id"], next);
        //   break;
        case 4:
          getVideos(userData["_id"], next);
          break;
        default:
          break;
      }
    }
  };
  const getVideos = async (id, next) => {
    try {
      setLoading(true);
      const response = await ApiService.GET_VIDEOS(
        `?id=${id}&pageNo=${next}&pageSize=16`
      );
      setLoaded(response["result"].length < 16 ? true : false);
      setVideos([...videos, ...response.result]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const handleVideoClick = (video) => {
    setVideo(video);
  };

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box>
            <Box>{children}</Box>
          </Box>
        )}
      </div>
    );
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  function a11yProps(index) {
    return {
      id: `full-width-tab-${index}`,
      "aria-controls": `full-width-tabpanel-${index}`,
      // icon: <img src={Images.topTab} />,
      // iconPosition: "start",
    };
  }

  const DragHandle = sortableHandle(() => (
    <DragIndicatorIcon
      title={"Move"}
      sx={{ color: "#fff", cursor: "pointer", marginLeft: "20px" }}
    />
  ));

  const times = Array(10).fill(null);

  const getTrendingMusic = async (_id) => {
    try {
      setLoading(true);
      const response = await ApiService.TRENDING(_id);
      setTrendingMusic({ ...response["result"] });
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    let isTrending =
      trendingMusic.topMusic?._id && trendingMusic.topPlaylist?._id;
    setIsTrending(isTrending);
  }, [trendingMusic]);

  const tempData = {
    _id: "649597a3f892d5252849d27e",
    isExplicit: false,
    views: 0,
    private: false,
    title: "Ambivali 4",
    artist: "Akshay",
    description: "best",
    releaseDate: "2023-06-23T00:00:00.000Z",
    thumbnailImg: {
      filePath:
        "https://d3u4prkqagliv8.cloudfront.net/027c5fe3-53ce-4b2c-ad08-7d5b0aab5e23.application/octet-stream",
    },
    fileId: {
      filePath:
        "https://d3u4prkqagliv8.cloudfront.net/5bb351ef680c9b020f30be5781a6622f.m4a",
      key: "5bb351ef680c9b020f30be5781a6622f.m4a",
    },
    duration: 46.144,
    uploader: {
      _id: "62288d109aaaae39736a8756",
      firstName: "Akshay",
      lastName: "",
      isFeatured: false,
      isActive: true,
      isVerified: true,
      profileImg: {
        filePath:
          "https://d3u4prkqagliv8.cloudfront.net/b0f32cd6-bdda-4867-8d3b-378dac668a12.application/octet-stream",
      },
      coverImg: {
        filePath:
          "https://d3u4prkqagliv8.cloudfront.net/ed2753b1-1078-44ba-b34e-c7043d57ddce.application/octet-stream",
      },
    },
    listenCount: 4,
    listens: 4,
    countValue: 4.1000346740638,
    ranking: "3",
    isSubscribed: false,
    topTipper: {
      musicId: "649597a3f892d5252849d27e",
      totalTippedAmount: 0.026549999999999997,
      topTipperId: "635a778742bfe711fa2dd61a",
      topTipperName: "*prajakta Duchale*",
      topTipperProfile: {
        filePath:
          "https://d3u4prkqagliv8.cloudfront.net/717e5241-f221-4c0f-8350-8b8afdd843d3.gif",
      },
    },
  };

  const playAll = async (index, music) => {
    if (
      active === 1 &&
      !isOwnerId(music[index]["createdBy"] ? music[index]["createdBy"] : "") &&
      !music[index]["isSubscribed"] &&
      music[index]["private"]
    ) {
      notifier.error(t("notifier.error.toast5"));
    } else if (music && music.length > 0) {
      if (active === 1) {
        history.push(`/app/Music/${music[index]["_id"]}`);
      } else if (active === 2) {
        history.push(`/app/MyNft/${music[index]["nftId"]}`);
      } else if (active === 3) {
        history.push(`/app/AlbumDetail/${music[index]["_id"]}`);
      } else {
        dispatch(
          addSongsAction(music, false, null, index !== undefined ? index : 0)
        );
      }
    }
  };

  const handleTrending = async (type) => {
    if (type === "music") {
      if (
        !trendingMusic?.topMusic["isSubscribed"] &&
        trendingMusic?.topMusic["private"]
      ) {
        notifier.error(t("notifier.error.toast5"));
      } else dispatch(addSongAction(trendingMusic?.topMusic));
    } else {
      history.push(`/app/Music/${trendingMusic?.topPlaylist?._id}`);
    }
  };

  const handleClick = () => {
    setOption(!option);
  };

  const handleClosed = () => {
    setOption(false);
  };

  const handleStudioShare = () => {
    setStudioOption(!option);
  };

  const handleCloseShare = () => {
    setStudioOption(false);
  };
  const handleCopy = async (action) => {
    const url = studioOption
      ? trendingMusic?.topPlaylist?.shareUrl?.shortLink
      : trendingMusic?.topMusic?.shareUrl?.shortLink ||
        (await dynamicLink(
          `/signup?returnUrl=/app/ArtistProfile/${userDetail._id}`
        ));

    const referralLink = studioOption
      ? trendingMusic?.topPlaylist?.shareUrl?.shortLink
      : trendingMusic?.topMusic?.shareUrl?.shortLink;

    // const url = trendingMusic?.topMusic?.shareUrl?.shortLink;
    switch (action) {
      case "m14":
        copyToClipboard(url);
        notifier.info("link copied");
        break;
      case "m15":
        onShare(action, url, {
          id: userDetail._id,
          // referralLink: trendingMusic?.topMusic?.shareUrl?.shortLink,
          referralLink: referralLink,
          eventType: ["sharedOutbound"],
          // eventAsset: playListId,
          eventAsset: userDetail._id,
          sharedBy: fullName(userDetail),
          eventValue: ["Studio"],
          socialMedia: "facebook",
        });
        break;
      case "m16":
        onShare(action, url, {
          id: userDetail._id,
          // referralLink: trendingMusic?.topMusic?.shareUrl?.shortLink,
          referralLink: referralLink,
          eventType: ["sharedOutbound"],
          eventAsset: userDetail._id,
          sharedBy: fullName(userDetail),
          eventValue: ["Studio"],
          socialMedia: "twitter",
        });
        break;
      case "Share on Instagram":
        onShare(action, url);
        break;
      default:
        break;
    }
  };

  return (
    <Box
      sx={{ position: "relative" }}
      onClick={() => {
        if (menu) {
          setMenu(false);
        }
      }}
    >
      <ProfileBanner
        userData={userData}
        edit={false}
        isArtist={true}
        loader={setLoading}
      />
      <Stack
        spacing={2}
        sx={{ textAlign: "center" }}
        className="_artistProfileBox"
      >
        <Stack alignItems="center">
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography
              sx={{
                fontSize: "20px !important",
                marginLeft: userData["isVerified"]
                  ? "18px !important"
                  : "10px !important",
              }}
              variant="body1"
              color="default"
            >
              {fullName(userData)}
            </Typography>
            {userData["isVerified"] ? (
              // <DoneIcon
              //   color="primary"
              //   sx={{
              //     backgroundColor: "#2CF488",
              //     borderRadius: "50%",
              //     fontSize: "14px",
              //     color: "#1E1E1E",
              //     padding: "2px",
              //   }}
              // />
              <img
                src={Images.verify}
                alt="verify"
                style={{ width: "18px", height: "18px" }}
              />
            ) : null}
          </Stack>

          {/* new artist profile */}
          {twitter || instagram || tiktok ? (
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-evenly"
              spacing={1}
              sx={{
                border: "0.5px solid #3E3E3E",
                borderRadius: "8px",
                height: "31px",
                width: "187px",
                marginTop: "20px",
              }}
            >
              {twitter ? (
                <a
                  href={
                    twitter.includes("https://")
                      ? twitter
                      : `https://www.twitter.com/${twitter}`
                  }
                  target="_blank"
                >
                  <img src={Images.twitter_t} height={15} width={15} />
                </a>
              ) : null}
              {instagram && twitter ? (
                <Divider
                  sx={{ color: "#3E3E3E", height: "20px" }}
                  orientation="vertical"
                />
              ) : null}
              {instagram ? (
                <a
                  href={
                    instagram.includes("https://")
                      ? instagram
                      : `https://www.instagram.com/${instagram}`
                  }
                  target="_blank"
                >
                  <img src={Images.instagram} height={15} width={15} />
                </a>
              ) : null}
              {instagram && tiktok ? (
                <Divider
                  sx={{ color: "#3E3E3E", height: "20px" }}
                  orientation="vertical"
                />
              ) : null}
              {tiktok ? (
                <a
                  href={
                    tiktok.includes("https://")
                      ? tiktok
                      : `https://www.tiktok.com/${tiktok}`
                  }
                  target="_blank"
                >
                  <img src={Images.tiktok} height={15} width={15} />
                </a>
              ) : null}
            </Stack>
          ) : null}

          <Typography
            sx={{
              fontSize: "14px !important",
              color: "#ffffff70",
              padding: "10px 40px",
            }}
          >
            {userData?.bio ?? ""}
          </Typography>

          {/* followers following box */}
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-evenly"
            spacing={1}
            sx={{
              border: "0.5px solid #3E3E3E",
              borderRadius: "8px",
              // height: "31px",
              // width: "187px",
              marginTop: "20px",
              padding: "10px 34px",
              [theme.breakpoints.down("sm")]: {
                padding: "20px 10px",
              },
            }}
          >
            <Stack
              direction="column"
              alignItems="center"
              sx={{
                cursor: "pointer",
                paddingRight: "34px",
                [theme.breakpoints.down("sm")]: {
                  paddingRight: "20px",
                },
              }}
              onClick={() =>
                history.push(`/app/Follow/${userData["_id"]}`, { userData })
              }
            >
              <Typography className="fs-20 fw-b _cp">
                {userData["followerCount"]}
              </Typography>
              <Stack direction="row" alignItems="center">
                <Typography className="fs-14 light-text _cp">
                  {t("artistProfile.followers")}
                </Typography>
                <ArrowForwardIosIcon
                  sx={{ fontSize: "14px" }}
                  color="default"
                />
              </Stack>
            </Stack>

            <Divider
              sx={{ color: "#3E3E3E", height: "40px" }}
              orientation="vertical"
            />
            <Stack
              direction="column"
              alignItems="center"
              sx={{
                cursor: "pointer",
                padding: isOwnerId(id) ? "0 0 0 34px" : "0 34px",
                [theme.breakpoints.down("sm")]: {
                  padding: isOwnerId(id) ? "0 0 0 20px" : "0 20px",
                },
              }}
              onClick={() =>
                history.push(`/app/Following/${userData["_id"]}`, {
                  userData,
                })
              }
            >
              <Typography className="fs-20 fw-b _cp">
                {userData["followingCount"]}
              </Typography>
              <Stack direction="row" alignItems="center">
                <Typography className="fs-14 light-text _cp">
                  {t("artistProfile.following")}
                </Typography>
                <ArrowForwardIosIcon
                  sx={{ fontSize: "14px" }}
                  color="default"
                />
              </Stack>
            </Stack>
            {isOwnerId(id) ? null : (
              <Divider
                sx={{ color: "#3E3E3E", height: "40px" }}
                orientation="vertical"
              />
            )}
            {isOwnerId(id) ? null : (
              <Stack
                direction="column"
                alignItems="center"
                sx={{
                  paddingLeft: "34px",
                  [theme.breakpoints.down("sm")]: {
                    paddingLeft: "20px",
                  },
                }}
              >
                <Typography className="fs-14 text-left">
                  {t("tipContainer.subHeader")}
                </Typography>
                <Stack
                  className="_cp"
                  direction="row"
                  alignItems="center"
                  gap="5px"
                  padding="8px"
                  onClick={() => setOpenTip(!open)}
                >
                  <img src={Images.tip_player} alt="tip_player" />
                  <Typography color="primary" className="fs-14 nowrap _cp">
                    {t("tipBox.button")}
                  </Typography>
                </Stack>
              </Stack>
            )}
          </Stack>
        </Stack>

        <Stack
          direction="row"
          alignItems="center"
          justifyContent="center"
          sx={{ gap: "24px", margin: "15px 0", position: "relative" }}
        >
          <Stack>
            {isOwnerId(id) ? null : (
              <Button
                variant="contained"
                color={userData["isFollowed"] ? "success" : "primary"}
                sx={{
                  height: "36px !important",
                  width: "110px",
                  fontSize: "13px !important",
                  marginLeft: "auto",
                }}
                onClick={() => follow(userData["_id"])}
                startIcon={
                  userData["isFollowed"] ? (
                    <img
                      className="_cp"
                      style={{ width: "14px", height: "15px" }}
                      src={Images.user_follow_yes}
                      alt="Insta"
                    />
                  ) : (
                    <img
                      className="_cp"
                      style={{ width: "13px", height: "16px" }}
                      src={Images.user_follow}
                      alt="Insta"
                    />
                  )
                }
              >
                {userData["isFollowed"] === false
                  ? t("follow.followList.button1")
                  : t("follow.followList.button2")}
              </Button>
            )}
          </Stack>
          <Stack>
            {isOwnerId(id) ? null : (
              <Button
                variant="outlined"
                sx={{
                  height: "36px !important",
                  width: "110px",
                  fontSize: "13px !important",
                  marginLeft: "auto",
                }}
                onClick={() => {
                  setMenu(!menu);
                }}
                color="default"
                // onClick={() => setShowConfirm(true)}
                endIcon={
                  <KeyboardArrowDownIcon
                    onClick={() => {
                      setMenu(!menu);
                    }}
                    style={{
                      transform: menu ? "rotate(180deg)" : "rotate(0deg)",
                    }}
                  />
                }
              >
                {t("artistProfile.button3")}
              </Button>
            )}

            {menu ? (
              <Box
                className="_artistMoreInfoInnerBox"
                sx={{
                  background: "#121515",
                  borderRadius: "16px",
                  padding: "16px",
                  zIndex: "1",
                  position: "absolute",
                  top: "40px",
                  left: "154px",
                  [theme.breakpoints.down("sm")]: {
                    left: "0px",
                  },
                }}
              >
                <Stack direction="row" justifyContent="space-between">
                  <Stack sx={{ textAlign: "left" }}>
                    <Typography
                      className="fs-13 fw-b"
                      style={{ color: "#5A5555" }}
                    >
                      {t("artistProfile.subscribe")}
                    </Typography>

                    <Typography
                      className="fs-20 light-text"
                      style={{ color: "#5A5555" }}
                    >
                      {userData["subscriptionFee"]} {t("artistProfile.coins")}{" "}
                      <small>{t("artistProfile.month")}</small>
                    </Typography>
                  </Stack>
                  {userData["subscriptionStatus"] === "enabled" &&
                  !isOwnerId(id) ? (
                    <Box>
                      {userData["isSubscribed"] === true &&
                      userData["subscribedStatus"] !== "Unsubscribed" ? (
                        <Button
                          variant="outlined"
                          color="default"
                          sx={{
                            height: "36px !important",
                            width: "110px",
                            fontSize: "13px !important",
                            marginLeft: "auto",
                          }}
                          onClick={() => unSubscribe()}
                        >
                          {t("artistProfile.button1")}
                        </Button>
                      ) : userData["isSubscribed"] === true &&
                        userData["subscribedStatus"] === "Unsubscribed" ? (
                        <Button
                          variant="outlined"
                          sx={{
                            height: "36px !important",
                            width: "auto",
                            fontSize: "13px !important",
                            marginLeft: "auto",
                          }}
                          color="default"
                          disabled={true}
                        >
                          {t("artistProfile.button2")}
                        </Button>
                      ) : (
                        <Button
                          variant="outlined"
                          sx={{
                            height: "36px !important",
                            width: "110px",
                            fontSize: "13px !important",
                            marginLeft: "auto",
                          }}
                          color="default"
                          onClick={() => setShowConfirm(true)}
                        >
                          {t("artistProfile.button3")}
                        </Button>
                      )}
                    </Box>
                  ) : null}
                </Stack>
                {userData["subscribedEndDate"] ? (
                  <Typography color="primary" className="fs-12 text-right">
                    {t("artistProfile.text2")}{" "}
                    {moment(
                      userData["subscribedEndDate"],
                      "DD-MM-YYYY'"
                    ).format("MM-DD-YYYY")}{" "}
                  </Typography>
                ) : null}

                <hr style={{ borderBottom: "#4D4D4D" }} />
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Stack direction="row" gap="10px">
                    <LockIcon
                      sx={{
                        backgroundColor: "#BDBDBD",
                        borderRadius: "50%",
                        fontSize: "14px",
                        padding: "2px",
                      }}
                    />
                    <Typography
                      className="fs-14 text-left"
                      style={{ color: "#5A5555" }}
                    >
                      {t("artistProfile.text1")}
                    </Typography>
                  </Stack>

                  <Typography
                    onClick={handleClickOpen}
                    color="primary"
                    className="fs-14 nowrap _cp"
                    style={{ marginLeft: "5px" }}
                  >
                    {t("artistProfile.text2")}
                  </Typography>
                </Stack>
              </Box>
            ) : null}
          </Stack>
        </Stack>
        {isTrending ? (
          <Divider sx={{ color: "#3E3E3E" }} orientation="horizontal" />
        ) : null}
        {/* <Box
          onClick={() => history.push(`/app/Leaderboard/${userData["_id"]}`)}
          className="_cp"
        >
          <img src={Images.level} style={{ width: "100%", margin: "auto" }} />
          <Stack
            direction="row"
            gap="8px"
            alignItems="baseline"
            marginTop="-15px"
            sx={{ width: "fit-content", margin: "-15px auto 0" }}
          >
            {[
              1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
              20, 21, 22, 23, 24, 25, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13,
              14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25,
            ].map((m, index) => (
              <Box key={index} sx={{ position: "relative" }}>
                <DoneIcon
                  className={
                    index < userData["avgLevel"]
                      ? "__level_graph"
                      : index == userData["avgLevel"]
                      ? "__level_graph1"
                      : "__level_graph2"
                  }
                />
                {index === userData["avgLevel"] ? (
                  <Stack
                    direction="row"
                    gap="2px"
                    sx={{
                      position: "absolute",
                      top: "-27px",
                      left: "-17px",
                      alignItems: "center",
                    }}
                  >
                    <Typography className="fs-13">
                      {t("artistProfile.level")}{" "}
                    </Typography>
                    <Typography className="fs-14">
                      {userData["avgLevel"]}
                    </Typography>
                    <img
                      style={{ transform: "rotateZ(180deg)", height: "14px" }}
                      src={Images.back}
                    />
                  </Stack>
                ) : null}
              </Box>
            ))}
          </Stack>
        </Box> */}

        {/* trending section */}
        {isTrending ? (
          <Typography sx={{ fontSize: "20px", margin: "24px 0" }}>
            {t("trending.text1")}
          </Typography>
        ) : null}
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="center"
          gap="35px"
          className="mb-20 wrap"
        >
          {trendingMusic.topMusic?._id ? (
            <Stack direction="row" alignItems="center" gap="20px">
              <Stack direction="column" alignItems="end" gap="3px">
                <Typography className="fs-13 fade-text">
                  {t("trending.text2")} #1
                </Typography>
                <Typography
                  className="fs-20 "
                  title={
                    trendingMusic?.topMusic?.title &&
                    trendingMusic?.topMusic?.title.length > 20
                      ? trendingMusic?.topMusic?.title
                      : ""
                  }
                >
                  {truncate(trendingMusic?.topMusic?.title, 20)}
                </Typography>
                <Stack direction="row">
                  <div className="_cp" onClick={(e) => handleTrending("music")}>
                    <PlayArrowRoundedIcon className="white-secondary" />
                  </div>
                  <HMSTag
                    className="white-secondary fs-14"
                    duration={trendingMusic?.topMusic?.duration}
                  />
                </Stack>

                <Stack direction="row" spacing={1}>
                  {/* <Stack direction="row" alignItems="center" spacing={1}>
                    <VisibilityIcon className="white-secondary" />{" "}
                    <Typography className="fs-14 white-secondary ">
                      {t("nftDetail.detail.views")}:{" "}
                      {trendingMusic?.topMusic?.views}
                    </Typography>
                  </Stack> */}
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <img
                      style={{ width: "15px", height: "15px" }}
                      src={Images.listen}
                    />
                    <Typography className="fs-14 white-secondary ">
                      {t("analytics.card.card3")}:{" "}
                      {trendingMusic?.topMusic?.listens}
                    </Typography>
                  </Stack>
                </Stack>

                <Stack
                  direction="row"
                  spacing={1}
                  alignItems="center"
                  sx={{ marginTop: "15px !important" }}
                >
                  <Box sx={{ width: "130px", height: "30px" }}></Box>
                  <IconButton
                    className="__icon_button"
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedAlbum(trendingMusic?.topMusic?._id);
                      setShowPlaylist(true);
                    }}
                  >
                    <img src={Images.playlist_add} alt="" />
                  </IconButton>

                  <Box
                    sx={{
                      position: "relative",
                    }}
                    className=" _cp"
                    color="default"
                  >
                    <Stack
                      sx={{
                        width: "48px",
                        height: "36px",
                        borderRadius: "24px",
                        border: "1px solid white",
                        position: "relative",
                      }}
                      className="__play_all"
                    >
                      <IosShareIcon
                        onClick={handleClick}
                        style={{
                          color: "white",
                          marginTop: "5px",
                          alignSelf: "center",
                        }}
                        className="__play_all_play"
                      />
                    </Stack>
                    {option ? (
                      <OutsideClickHandler
                        onOutsideClick={() => {
                          handleClosed();
                        }}
                      >
                        <DropMenu
                          right={""}
                          isHeader={true}
                          isLast={"50px !important"}
                          actions={[
                            { key: "m14", action: t("dropMenu.m14") },
                            {
                              key: "m15",
                              action: t("dropMenu.m15"),
                            },
                            {
                              key: "m16",
                              action: t("dropMenu.m16"),
                            },
                            // "Share on Instagram",
                            ,
                          ]}
                          toggleMenu={(action) => (
                            handleCopy(action), handleClosed()
                          )}
                        />
                      </OutsideClickHandler>
                    ) : null}
                  </Box>
                </Stack>
              </Stack>

              <Box
                sx={{
                  height: "166px",
                  width: "166px",
                  borderRadius: "15px",
                  position: "relative",
                }}
              >
                <img
                  src={
                    trendingMusic?.topMusic?.thumbnailImg?.filePath ??
                    Images.dummy1
                  }
                  alt="music"
                  height="166px"
                  width="166px"
                  style={{ borderRadius: "15px" }}
                />
                <img
                  onClick={(e) => handleTrending("music")}
                  className="__play_hover _cp"
                  src={Images.play}
                  alt="play"
                  style={{ position: "absolute", bottom: "10px", left: "10px" }}
                />
              </Box>
            </Stack>
          ) : null}
          {isTrending && window.innerWidth > 992 ? (
            <Divider
              sx={{ color: "#3E3E3E", height: "166px" }}
              orientation="vertical"
            />
          ) : null}
          {trendingMusic.topPlaylist?._id ? (
            <Stack direction="row" alignItems="center" gap="20px">
              <Box
                sx={{
                  height: "166px",
                  width: "166px",
                  borderRadius: "5px",
                  position: "relative",
                }}
              >
                <img
                  src={trendingMusic?.topPlaylist?.thumbnailImg?.filePath}
                  alt="studio"
                  height="166px"
                  width="166px"
                  style={{ borderRadius: "15px" }}
                />
                <img
                  onClick={(e) => handleTrending("studio")}
                  className="__play_hover _cp"
                  src={Images.play}
                  alt="play"
                  style={{ position: "absolute", bottom: "10px", left: "10px" }}
                />
              </Box>
              <Stack direction="column" alignItems="start" gap="3px">
                <Typography className="fs-13 fade-text">
                  {t("trending.text3")} #1
                </Typography>
                <Typography
                  className="fs-20 "
                  title={
                    trendingMusic?.topPlaylist?.title &&
                    trendingMusic?.topPlaylist?.title.length > 20
                      ? trendingMusic?.topPlaylist?.title
                      : ""
                  }
                >
                  {truncate(trendingMusic?.topPlaylist?.title, 20)}
                </Typography>
                <Stack direction="row">
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <img src={Images.music_hover} alt="music" />
                    <Typography className="fs-14 white-secondary ">
                      {trendingMusic?.topPlaylist?.music.length}{" "}
                      {t("nftDetail.music.th1")}
                    </Typography>
                  </Stack>
                  <Divider
                    sx={{
                      color: "#3E3E3E",
                      height: "20px",
                      marginLeft: "10px",
                    }}
                    orientation="vertical"
                  />
                  <div
                    className="_cp"
                    onClick={(e) => handleTrending("studio")}
                  >
                    <PlayArrowRoundedIcon className="white-secondary" />
                  </div>
                  <HMSTag
                    className="white-secondary fs-14"
                    duration={trendingMusic?.topPlaylist?.duration}
                  />
                </Stack>

                <Stack direction="row" spacing={1}>
                  {/* <Stack direction="row" alignItems="center" spacing={1}>
                    <VisibilityIcon className="white-secondary" />{" "}
                    <Typography className="fs-14 white-secondary ">
                      {t("nftDetail.detail.views")}:{" "}
                      {trendingMusic?.topPlaylist?.views}
                    </Typography>
                  </Stack> */}
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <img
                      style={{ width: "15px", height: "15px" }}
                      src={Images.listen}
                    />
                    <Typography className="fs-14 white-secondary ">
                      {t("analytics.card.card3")}:{" "}
                      {trendingMusic?.topPlaylist?.listens}
                    </Typography>
                  </Stack>
                </Stack>

                <Stack
                  direction="row"
                  spacing={1}
                  alignItems="center"
                  sx={{ marginTop: "15px !important" }}
                >
                  <Button
                    sx={{ whiteSpace: "pre" }}
                    variant="outlined"
                    color="default"
                    startIcon={<img src={Images.activity} alt="" />}
                    onClick={() =>
                      history.push(
                        `/app/PlaylistStatics/${trendingMusic?.topPlaylist?._id}/${trendingMusic?.topPlaylist?.owner}`
                      )
                    }
                  >
                    {t("nftDetail.detail.statics")}
                  </Button>

                  <Box
                    sx={{
                      position: "relative",
                    }}
                    className=" _cp"
                    color="default"
                  >
                    <Stack
                      sx={{
                        width: "48px",
                        height: "36px",
                        borderRadius: "24px",
                        border: "1px solid white",
                        position: "relative",
                      }}
                      className="__play_all"
                    >
                      <IosShareIcon
                        onClick={handleStudioShare}
                        style={{
                          color: "white",
                          marginTop: "5px",
                          alignSelf: "center",
                        }}
                        className="__play_all_play"
                      />
                    </Stack>
                    {studioOption ? (
                      <OutsideClickHandler
                        onOutsideClick={() => {
                          handleCloseShare();
                        }}
                      >
                        <DropMenu
                          right={""}
                          isHeader={true}
                          isLast={"50px !important"}
                          actions={[
                            { key: "m14", action: t("dropMenu.m14") },
                            {
                              key: "m15",
                              action: t("dropMenu.m15"),
                            },
                            {
                              key: "m16",
                              action: t("dropMenu.m16"),
                            },
                            // "Share on Instagram",
                            ,
                          ]}
                          toggleMenu={(action) => (
                            handleCopy(action), handleCloseShare()
                          )}
                        />
                      </OutsideClickHandler>
                    ) : null}
                  </Box>
                </Stack>
              </Stack>
            </Stack>
          ) : null}

          {/* <Stack direction="row" alignItems="center" gap="10px">
            {userData["twitterLink"] ? (
              <Box
                className="social-box"
                onClick={() => {
                  validateUrl("https://twitter.com/" + userData["twitterLink"])
                    ? window.open(
                        "https://twitter.com/" + userData["twitterLink"],
                        "_blank"
                      )
                    : notifier.info("Unable to open link Please check URL");
                }}
              >
                <TwitterIcon className="_cp" sx={{ color: "#00AAEC" }} />
              </Box>
            ) : null}
            {userData["instagramLink"] ? (
              <Box
                className="social-box"
                onClick={() => {
                  validateUrl(
                    "https://www.instagram.com/" + userData["instagramLink"]
                  )
                    ? window.open(
                        "https://www.instagram.com/" +
                          userData["instagramLink"],
                        "_blank"
                      )
                    : notifier.info("Unable to open link Please check URL");
                }}
              >
                <img
                  className="_cp"
                  style={{ width: "20px", height: "20px" }}
                  src={Images.instagram}
                  alt="Insta"
                />
              </Box>
            ) : null}
            {userData["tikTokLink"] ? (
              <Box
                className="social-box"
                onClick={() => {
                  validateUrl(
                    "https://www.tiktok.com/en/" + userData["tikTokLink"]
                  )
                    ? window.open(
                        "https://www.tiktok.com/en/" + userData["tikTokLink"],
                        "_blank"
                      )
                    : notifier.info("Unable to open link Please check URL");
                }}
              >
                <img
                  style={{ width: "20px", height: "20px" }}
                  src={Images.tiktok}
                  alt="Insta"
                />
              </Box>
            ) : null}
            {/* Compress for now  */}
          {isOwnerId(id) ? null : (
            <Box
              className="artist_dm_chat _cp"
              onClick={(e) => {
                setChatOpen(true);
              }}
            >
              <img
                title={`Chat with ${userName}`}
                style={{ width: "20px", height: "20px" }}
                src={Images.direct_chat}
                alt="Insta"
              />
            </Box>
          )}
          {/* </Stack> */}
        </Stack>

        <Divider sx={{ color: "#3E3E3E" }} orientation="horizontal" />

        {/* <Stack direction="row" gap="24px" className="__artistProfileMoreInfo">
          <Box
            className="_artistMoreInfoInnerBox"
            sx={{
              // background: "#262626",
              background: "#090909",
              borderRadius: "16px",
              padding: "16px",
            }}
          >
            <Stack direction="row">
              <Stack
                sx={{ textAlign: "left", cursor: "pointer" }}
                onClick={() =>
                  history.push(`/app/Follow/${userData["_id"]}`, { userData })
                }
              >
                <Typography className="fs-13 fw-b _cp">
                  {userData["followerCount"]}
                </Typography>
                <Stack direction="row" alignItems="center">
                  <Typography className="fs-13 light-text _cp">
                    {t("artistProfile.followers")}
                  </Typography>
                  <ArrowForwardIosIcon
                    sx={{ fontSize: "14px" }}
                    color="default"
                  />
                </Stack>
              </Stack>
              <Stack
                sx={{
                  textAlign: "left",
                  cursor: "pointer",
                  marginLeft: "30px",
                }}
                onClick={() =>
                  history.push(`/app/Following/${userData["_id"]}`, {
                    userData,
                  })
                }
              >
                <Typography className="fs-13 fw-b _cp">
                  {userData["followingCount"]}
                </Typography>
                <Stack direction="row" alignItems="center">
                  <Typography className="fs-13 light-text _cp">
                    {t("artistProfile.following")}
                  </Typography>
                  <ArrowForwardIosIcon
                    sx={{ fontSize: "14px" }}
                    color="default"
                  />
                </Stack>
              </Stack>
              {isOwnerId(id) ? null : (
                <Button
                  variant="contained"
                  color={userData["isFollowed"] ? "success" : "primary"}
                  sx={{
                    height: "36px !important",
                    width: "110px",
                    fontSize: "13px !important",
                    marginLeft: "auto",
                  }}
                  onClick={() => follow(userData["_id"])}
                  startIcon={
                    userData["isFollowed"] ? (
                      <PersonAddAltIcon
                        color={userData["isFollowed"] ? "default" : "secondary"}
                        sx={{
                          fontSize: "14px !important",
                          padding: "2px",
                        }}
                      />
                    ) : null
                  }
                >
                  {userData["isFollowed"] === false
                    ? t("follow.followList.button1")
                    : t("follow.followList.button2")}
                </Button>
              )}
            </Stack>
            <hr style={{ borderBottom: "#4D4D4D" }} />
            {isOwnerId(id) ? null : (
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography className="fs-14 text-left">
                  {t("tipContainer.subHeader3")}
                </Typography>
                <Stack
                  className="_cp"
                  direction="row"
                  alignItems="center"
                  gap="5px"
                  padding="8px"
                  onClick={() => setOpenTip(!open)}
                >
                  <img src={Images.tip_player} alt="tip_player" />
                  <Typography color="primary" className="fs-14 nowrap _cp">
                    {t("tipBox.button")}
                  </Typography>
                </Stack>
              </Stack>
            )}
          </Box>
          <Box
            className="_artistMoreInfoInnerBox"
            sx={{
              // background: "#262626",
              background: "#090909",
              borderRadius: "16px",
              padding: "16px",
            }}
          >
            <Stack direction="row" justifyContent="space-between">
              <Stack sx={{ textAlign: "left" }}>
                <Typography className="fs-13 fw-b">
                  {t("artistProfile.subscribe")}
                </Typography>

                <Typography className="fs-13 light-text">
                  {userData["subscriptionFee"]} {t("artistProfile.coins")}{" "}
                  <small>{t("artistProfile.month")}</small>
                </Typography>
              </Stack>
              {userData["subscriptionStatus"] === "enabled" &&
              !isOwnerId(id) ? (
                <Box>
                  {userData["isSubscribed"] === true &&
                  userData["subscribedStatus"] !== "Unsubscribed" ? (
                    <Button
                      variant="outlined"
                      color="default"
                      sx={{
                        height: "36px !important",
                        width: "110px",
                        fontSize: "13px !important",
                        marginLeft: "auto",
                      }}
                      onClick={() => unSubscribe()}
                    >
                      {t("artistProfile.button1")}
                    </Button>
                  ) : userData["isSubscribed"] === true &&
                    userData["subscribedStatus"] === "Unsubscribed" ? (
                    <Button
                      variant="outlined"
                      sx={{
                        height: "36px !important",
                        width: "auto",
                        fontSize: "13px !important",
                        marginLeft: "auto",
                      }}
                      color="default"
                      disabled={true}
                    >
                      {t("artistProfile.button2")}
                    </Button>
                  ) : (
                    <Button
                      variant="outlined"
                      sx={{
                        height: "36px !important",
                        width: "110px",
                        fontSize: "13px !important",
                        marginLeft: "auto",
                      }}
                      color="default"
                      onClick={() => setShowConfirm(true)}
                    >
                      {t("artistProfile.button3")}
                    </Button>
                  )}
                </Box>
              ) : null}
            </Stack>
            {userData["subscribedEndDate"] ? (
              <Typography color="primary" className="fs-12 text-right">
                {t("artistProfile.text2")}{" "}
                {moment(userData["subscribedEndDate"], "DD-MM-YYYY'").format(
                  "MM-DD-YYYY"
                )}{" "}
              </Typography>
            ) : null}

            <hr style={{ borderBottom: "#4D4D4D" }} />
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Stack direction="row" gap="10px">
                <LockIcon
                  sx={{
                    backgroundColor: "#BDBDBD",
                    borderRadius: "50%",
                    fontSize: "14px",
                    padding: "2px",
                  }}
                />
                <Typography className="fs-14 text-left">
                  {t("artistProfile.text1")}
                </Typography>
              </Stack>

              <Typography
                onClick={handleClickOpen}
                color="primary"
                className="fs-14 nowrap _cp"
              >
                {t("artistProfile.text2")}
              </Typography>
            </Stack>
          </Box>
        </Stack> */}

        {/* List section */}
        <Stack>
          <ArtistContent
            id={id}
            userData={userData}
            getPlayListMusic={getPlayListMusic}
            playlistNft={playlistNft}
          />
        </Stack>

        {/* chips tabs */}
        {/* <Stack>
          <Stack spacing={1} direction="row" justifyContent="center">
            {[
              t("artistProfile.tabs.tab1"),
              t("artistProfile.tabs.tab2"),
              t("artistProfile.tabs.tab3"),
              t("artistProfile.tabs.tab4"),
              t("artistProfile.tabs.tab5"),
              // t("artistProfile.tabs.tab6"),
            ].map((label, index) => (
              <Chips
                key={index}
                label={label}
                index={index}
                activeTab={active}
                handleClick={(tab) => handleTabSwitch(tab)}
              />
            ))}
          </Stack>
          <Stack
            sx={{ position: "relative", padding: "0 0 100px 0" }}
            spacing={2}
          >
            {userData["top5Music"] && active === 0 ? (
              <Stack spacing={1} sx={{ position: "relative" }}>
                <Typography className="fs-17 text-left">
                  {t("artistProfile.title1")}
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    gap: "15px",
                    flexWrap: "wrap",
                  }}
                >
                  {userData["top5Music"] &&
                    userData["top5Music"].map((music, index) => (
                      <MusicCard
                        isMusic={true}
                        key={index}
                        music={music}
                        actions={[
                          { key: "m2", action: t("dropMenu.m2") },
                          { key: "m3", action: t("dropMenu.m3") },
                          { key: "m1", action: t("dropMenu.m1") },
                        ]}
                        toggleMenu={(action, id) => {
                          toggleMenu(action, id, index, 0);
                        }}
                      />
                    ))}
                </Box>
              </Stack>
            ) : active === 1 && music.length > 0 ? (
              <Stack spacing={1} sx={{ position: "relative" }}>
                <Typography className="fs-17 text-left">
                  {t("artistProfile.title2")}
                </Typography>
                <Box
                  onScroll={(e) => handleScroll(e.target)}
                  sx={{
                    display: "flex",
                    gap: "15px",
                    flexWrap: "wrap",
                    maxHeight: "100vh",
                    overflow: "scroll",
                  }}
                >
                  {music &&
                    music.map((music, index) => (
                      <MusicCard
                        nftId={music.nftId}
                        isNft={music.nftId ? true : false}
                        platform={music.platform}
                        isMusic={true}
                        key={index}
                        music={music}
                        actions={[
                          { key: "m2", action: t("dropMenu.m2") },
                          { key: "m3", action: t("dropMenu.m3") },
                          { key: "m1", action: t("dropMenu.m1") },
                        ]}
                        toggleMenu={(action, id) =>
                          action === "m8"
                            ? toggleMenu(action, id, index, 3, false, true)
                            : toggleMenu(action, id, index, 1)
                        }
                      />
                    ))}
                </Box>
              </Stack>
            ) : active === 2 && playlistMusic.length > 0 ? (
              <Stack spacing={1} sx={{ position: "relative" }}>
                <Typography className="fs-17 text-left">
                  {t("artistProfile.title3")}
                </Typography>
                <Box
                  onScroll={(e) => handleScroll(e.target)}
                  sx={{
                    display: "flex",
                    gap: "15px",
                    flexWrap: "wrap",
                    maxHeight: "100vh",
                    overflow: "scroll",
                  }}
                >
                  {playlistMusic &&
                    playlistMusic.map((pMusic, index) => (
                      <MusicCard
                        isPlaylistNft={pMusic.nftId ? true : false}
                        nftId={pMusic.nftId}
                        platform={pMusic.platform}
                        isPlaylist={true}
                        isSubscribed={pMusic["isSubscribed"]}
                        isPrivate={pMusic["private"]}
                        key={index}
                        music={pMusic}
                        onNavigate={() => {
                          !isOwnerId(pMusic["createdBy"]) &&
                            !pMusic["isSubscribed"] &&
                            pMusic["private"]
                            ? notifier.error(t("notifier.error.toast15"))
                            : history.push(`/app/Music/${pMusic["_id"]}`);
                        }}
                        actions={[
                          { key: "m26", action: t("dropMenu.m26") },
                          { key: "m27", action: t("dropMenu.m27") },
                          { key: "m8", action: t("dropMenu.m8") },
                        ]}
                        toggleMenu={(action, id) =>
                          toggleMenu(action, id, index, 2, true)
                        }
                      />
                    ))}
                </Box>
              </Stack>
            ) : active === 3 && nftMusic.length > 0 ? (
              <Stack spacing={1} sx={{ position: "relative" }}>
                <Typography className="fs-17 text-left">
                  {t("artistProfile.title4")}
                </Typography>
                <Box
                  onScroll={(e) => handleScroll(e.target)}
                  sx={{
                    display: "flex",
                    gap: "15px",
                    flexWrap: "wrap",
                    maxHeight: "100vh",
                    overflow: "scroll",
                  }}
                >
                  {nftMusic &&
                    nftMusic.map((nMusic, index) => (
                      <MusicCard
                        platform={nMusic.platform}
                        isNft={true}
                        nftId={nMusic["nftId"]}
                        key={index}
                        isPrivate={nMusic["private"]}
                        isSubscribed={nMusic["isSubscribed"]}
                        music={
                          nMusic["musicDetails"]
                            ? nMusic["musicDetails"]
                            : nMusic
                        }
                        actions={[
                          { key: "m3", action: t("dropMenu.m3") },
                          { key: "m2", action: t("dropMenu.m2") },
                          { key: "m1", action: t("dropMenu.m1") },
                          { key: "m8", action: t("dropMenu.m8") },
                        ]}
                        toggleMenu={(action, id) =>
                          toggleMenu(action, id, index, 3)
                        }
                      />
                    ))}
                </Box>
              </Stack>
            ) : active === 4 && albums.length > 0 ? (
              <Stack spacing={1} sx={{ position: "relative" }}>
                <Typography className="fs-17 text-left">
                  {t("artistProfile.title5")}
                </Typography>
                <Box
                  onScroll={(e) => handleScroll(e.target)}
                  sx={{
                    display: "flex",
                    gap: "15px",
                    flexWrap: "wrap",
                    maxHeight: "100vh",
                    overflow: "scroll",
                  }}
                >
                  {albums &&
                    albums.map((aMusic, index) => (
                      <MusicCard
                        isAlbum={true}
                        key={index}
                        music={
                          aMusic["musicDetails"]
                            ? aMusic["musicDetails"]
                            : aMusic
                        }
                        actions={[
                          { key: "m26", action: t("dropMenu.m26") },
                          { key: "m28", action: t("dropMenu.m28") },
                        ]}
                        toggleMenu={(action, id) =>
                          toggleMenu(action, aMusic._id, index, 4)
                        }
                      />
                    ))}
                </Box>
              </Stack>
            ) : active === 5 ? (
              <Stack spacing={1} sx={{ position: "relative" }}>
                <Typography className="fs-17 text-left">
                  {t("artistProfile.title6")}
                </Typography>
                <Box
                  onScroll={(e) => handleScroll(e.target)}
                  sx={{
                    display: "flex",
                    gap: "15px",
                    flexWrap: "wrap",
                    maxHeight: "100vh",
                    overflow: "scroll",
                  }}
                >
                  {videos &&
                    videos.map((vid, index) => (
                      <VideoCard
                        key={index}
                        video={vid?.url}
                        onVideoClick={(index) => {
                          handleVideoClick(vid?.url);
                        }}
                      />
                    ))}
                </Box>
              </Stack>
            ) : (
              <Stack sx={{ minHeight: "100px", position: "relative" }}>
                <NoData lable={t("noData.noData")} />
              </Stack>
            )}
            {isOwnerId(id) ? null : (
              <Stack spacing={1}>
                <Stack spacing={1} direction="row" alignItems="center">
                  <img src={Images.flag} alt="flag" />
                  <Typography className="fs-13 fade-text">
                    {t("flagArtist")}
                  </Typography>
                </Stack>
                <Stack spacing={1} alignItems="flex-start">
                  <Typography className="fs-15 fade-text">
                    {t("flagMsg")}
                  </Typography>
                  <Button
                    variant="outlined"
                    color="default"
                    className="fs-15"
                    onClick={() => flaguser()}
                  >
                    {t("flag")}
                  </Button>
                </Stack>
              </Stack>
            )}
          </Stack>
        </Stack> */}
      </Stack>
      {chatOpen ? (
        <DirectChat
          senderUserId={userData["_id"]}
          title={fullName(userData)}
          onOutsideClick={() => {
            setChatOpen(false);
          }}
          onOpenTip={() => setOpenTip(true)}
          artistChat={true}
        />
      ) : null}
      {openTip ? (
        <TipPopup
          artist={fullName(userData ? userData : "")}
          id={userData["_id"]}
          open={openTip}
          isArtist={true}
          handleClose={handleTip}
        />
      ) : null}
      {open ? (
        <SuccessPopup
          message={message}
          open={open}
          handleClose={() => setOpen(false)}
        />
      ) : null}
      {viewAsset ? (
        <AssetPopup
          id={userData["_id"]}
          open={viewAsset}
          handleClose={(e) => {
            handleClose(e);
            // setOpen(e);
          }}
        />
      ) : null}

      {showPlaylist ? (
        <AddMusicToPlaylist
          musicId={selectedId}
          open={showPlaylist}
          handleClose={() => setShowPlaylist(false)}
        />
      ) : null}
      {loading ? <Loader /> : null}
      {showConfirm ? (
        <ConfirmPopup
          open={showConfirm}
          id={userData["_id"]}
          index={0}
          message={`${t("confirmPopup.text3")} ${
            userData["subscriptionFee"]
          } SIKI coins.`}
          handleClose={(e) => (e ? subscribe() : setShowConfirm(false))}
        />
      ) : null}
      {video ? (
        <VideoPopup
          open={video ? true : false}
          video={video}
          handleClose={() => setVideo(null)}
        />
      ) : null}
    </Box>
  );
}
